function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Dollar"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 20,
  "data-height": 32,
  transform: "translate(6)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2,
  className: "iconic-dollar-vertical-line iconic-property-stroke",
  fill: "none",
  d: "M10 32v-32"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 4,
  d: "M17 11c0-4-1.643-6.5-7-6.5-7.501 0-7 4.673-7 5.747 0 8.053 15 3.45 15 11.503 0 1.143-.501 5.75-8 5.75-5.358 0-8-2.5-8-6.5",
  className: "iconic-dollar-s-curve iconic-property-stroke",
  fill: "none"
}));

function SvgDollarMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "dollar",
    className: "iconic iconic-dollar iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarMd);
export default __webpack_public_path__ + "static/media/dollar-md.d8fb9221.svg";
export { ForwardRef as ReactComponent };